export default __webpack_public_path__ + "static/media/Mylib.c261754f.png";